import React, { useEffect } from 'react';
import LoginForm from '../../components/loginForm/loginForm';
import "./login.scss";
import LoginInnerContent from '../../components/loginForm/loginInnerCard';
import { useNavigate } from 'react-router-dom';

const Login: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            navigate('/dashboard');
        }
    }, [navigate]);
    return (
        <div className="container-fluid clientAdmin">
            <div className="row g-3">
                <div className="col-md-8">
                    <div className="bg-image-primary">
                        <LoginInnerContent />
                    </div>
                </div>
                <div className="col-md-4 d-flex">
                    <div className="position-relative col-12 d-flex align-items-center justify-content-center flex-column bg-dark text-white rounded-20 bg-image-secondary"
                    >
                        <LoginForm />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
